import { Injectable, inject } from "@angular/core";
import { isEmpty } from "lodash";
import { map, Observable, of, switchMap } from "rxjs";
import { environment } from "../../../../environments/environment";
import { InstallationMenuItemNew } from "../../../shared/sidebar/sidebar-installations-menu/models/installation-menu-item.model";
import { InstallationSelectors } from "../../../state/installations-state/installation-state.selectors";
import { BreeceApiService, CustomHttpPrams } from "../breece-api.service";
import { InstallationTreeApiService } from "../installation-tree/installation-tree.api-service";
import { InstallationsMapper } from "./mapper/installations.mapper";
import { IInstallationMenuItem } from "./response/installation-menu-item.response";
import { ITopGroup } from "./response/top-group.response";
import { HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class InstallationsApiService extends BreeceApiService {
  protected override baseApi: string = environment.breeceInstallationsApiUrl;

  constructor() {
    super();
    // Renames/moves/creates/deletes on the installation tree page change what this service's
    // cached menu data describes - drop the cache so the next menu open fetches fresh.
    inject(InstallationTreeApiService).mutated$.subscribe(() => this.clearCache());
  }


  getTopGroupMenuItems(): Observable<ITopGroup[]> {
    return this.getWithCached<ITopGroup[]>("/Groups");
  }

  getInstallationsOnGroupMenuItems(recCode: string): Observable<InstallationMenuItemNew[]> {
    return this.getWithCached<IInstallationMenuItem[]>(`/Groups/${recCode}/Installations`).pipe(
      map(insts => InstallationsMapper.mapInstallationMenuItemsResponse(insts))
    );
  }

  searchInstallations(search: string | null, top: number): Observable<InstallationMenuItemNew[]> {
    if (isEmpty(search) || search == null) return of([]);

    var params: CustomHttpPrams[] = [{ key: 'searchText', value: search }, {key: 'top', value: top}]

    return this.getWithCached<IInstallationMenuItem[]>(`/Installations/search`, params).pipe(map(insts => InstallationsMapper.mapInstallationMenuItemsResponse(insts)))
  }

  getInstallationDetails(refCode: string): Observable<InstallationMenuItemNew> {
    if (!refCode)
      return of();

    return this.getWithCached<IInstallationMenuItem>(`/Installations/${refCode}`).pipe(map(inst => InstallationsMapper.mapInstallationMenuItemResponse(inst)));

  }

  getLatestOrDefaultRefCode(): Observable<string | undefined> {
    return this.store.select(InstallationSelectors.getLatestInstallations).pipe(
      map(latest => {
        if (latest && latest.length > 0) {
          return latest[0].refCode; // take first latest
        }
        return undefined;
      }),
      switchMap(refCode => {
        if (refCode) {
          return of(refCode);
        }

        // Get the first/default top group
        return this.getTopGroupMenuItems().pipe(
          map(items => items?.[0]?.refCode)
        );
      })
    );
  }
  getLatestInstallationsNew(): Observable<InstallationMenuItemNew[]> {
    return this.getWithCached<IInstallationMenuItem[]>(`/LatestInstallations`).pipe(
      map(insts => InstallationsMapper.mapInstallationMenuItemsResponse(insts))
    );
  }
  addLatestInstallations(refCode: string): Observable<InstallationMenuItemNew[]> {
    return this.post<IInstallationMenuItem[]>(`/LatestInstallations`, { refCode: refCode }).pipe(
      map(insts => InstallationsMapper.mapInstallationMenuItemsResponse(insts))
    );
  }
}